import { appInitialState } from "./app-reducer"
const { settings: {
  fonts: initialFonts
} } = appInitialState


export const getFonts = (fonts) => {
  const titleFontFamily = fonts?.titleFamily ? fonts.titleFamily : initialFonts.titleFamily
  const titleFontWeight = fonts?.titleWeight ? fonts.titleWeight : initialFonts.titleWeight
  const textFontFamily = fonts?.textFamily ? fonts.textFamily : initialFonts.textFamily
  const textFontWeight = fonts?.textWeight ? fonts.textWeight : initialFonts.textWeight
  return {
    titleFontFamily,
    titleFontWeight,
    textFontFamily,
    textFontWeight,
  }
}

export const getFontsQueryParam = (fontFamily, weight) => {
  const fontFamilyParam = fontFamily.split(" ").join("+");
  const weightParam = typeof weight === "string" && weight.includes("italic") ? `:ital,wght@1,${weight.replace("italic", "")}` : `:wght@${weight}`;
  return `family=${fontFamilyParam}${weightParam}&display=swap`;
};